import { WidgetDefinition } from '../models/WidgetDefinition';

export const BusinessKpiWidgetDefinition: WidgetDefinition = {
    baseType: 'businessKpi',
    group: 'Charts',
    hasImage: true,
    highlights: ['List of horizontal gauges', 'You can also show a target value and an expected range'],
    icon: 'fa-dashboard',
    sortingOrder: 400,
    title: 'Business KPI',
    type: 'businessKpi'
};